module.exports = __webpack_public_path__ + "img/toast-img.e4f98fed.png";